import {
  ExitIcon,
  GlobalIcon,
} from '@linetweet/linetweet-ui';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';

import { ROUTES } from '../../data/routes';

export const topItems: { icon: any, text: string, link: string }[] = [
  { icon: TuneOutlinedIcon, text: 'common.storeSettingsMenuItem', link: ROUTES.PERFORMANCE_INDICATORS },
  // { icon: WidgetsIcon, text: 'common.featureActivations', link: ROUTES.FEATURES },
  // { icon: TimerIcon, text: 'common.servicesConfiguration', link: ROUTES.SERVICES },
  // { icon: ManageAccountsIcon, text: 'common.resourcesConfiguration', link: ROUTES.RESOURCES },
  // { icon: EditCalendarIcon, text: 'common.appointmentBookingConfiguration', link: ROUTES.APPOINTMENTS },
];

export const bottomItems: { icon: any, text: string, type?: string, link?: string }[] = [
  { icon: GlobalIcon, text: 'common.selectLanguage', type: 'language' },
  // { icon: MailIcon, text: 'common.helpContact', link: ROUTES.HELP_CONTACT },
  { icon: ExitIcon, text: 'common.signOut', type: 'sign_out' },
];
